import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Create a date formatting function based on the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request, ensuring it is required
        const cur_user = this.getParam('user', true);
        // Extend the default Webix data filter to create a custom summary column filter
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                /**
                 * Refreshes the summary column with the calculated total value.
                 * @param {Object} master - The master view containing the data.
                 * @param {HTMLElement} node - The DOM node representing the summary cell.
                 * @param {Object} value - The value object containing column information.
                 */
                refresh: function(master, node, value) {
                    var result = 0; // Initialize the result accumulator for the sum
                    var resultFormat = 0; // Variable to hold the formatted result
                    var size = $$('table').getPager().config.size; // Get the current page size
                    var page = $$('table').getPage(); // Get the current page number
                    var first = size * page; // Calculate the index of the first item on the current page
                    var last = first + size - 1; // Calculate the index of the last item on the current page
                    var count = 0; // Initialize a counter for iterating through the data
                    // Iterate through each data object in the master view
                    master.data.each(function(obj) {
                        // Check if the current index is within the bounds of the current page
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Accumulate the sum of the specified column
                        }
                        count++; // Increment the counter
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result as a price
                    node.firstChild.innerHTML = resultFormat; // Update the summary cell with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend the existing summary column filter
        );

        /**
         * Configuration object for a Webix datatable.
         * Defines the layout, columns, and behavior of the datatable.
         */
        return {
            view: 'datatable', // Specifies the datatable view
            id: 'table', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            scroll: true, // Enables scrolling
            columns: [
                {
                    id: 'TypeName', // Column ID
                    header: 'TypeName', // Column header
                    width: 200, // Column width
                    template: function(obj, common) {
                        // Template for rendering the column content
                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                        return obj.TypeName;
                    },
                    footer: 'Total:', // Footer text
                },
                {
                    id: 'ActionTittle', // Column ID
                    header: '', // Empty header
                    width: 70, // Column width
                    height: 25, // Column height
                    tooltip: _('Acción'), // Tooltip text
                    template: function(obj) {
                        // Template for rendering action buttons based on state
                        if (obj.State == 'E' || obj.State == null) {
                            if (devConfig.getPermAction('comissionsReportBetShopDetailApprove', 'Approve')) {
                                return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close approve prm-comissionsReportBetShopDetailApprove\'></span></span><span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsReportBetShopDetailApprove\'></span>';
                            } else {
                                return '';
                            }
                        } else {
                            if (obj.State == 'A' || obj.State == null) {
                                if (devConfig.getPermAction('comissionsReportBetShopDetailPay', 'Pay')) {
                                    return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsReportBetShopDetailPay\'></span>';
                                } else {
                                    return '';
                                }
                            } else {
                                return '';
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // ID column with sorting
                {
                    id: 'ClientId', // Column ID
                    header: _('ID Usuario'), // Localized header
                    width: 95, // Column width
                    sort: 'int', // Enables integer sorting
                },
                {
                    id: 'CreatedLocal', // Column ID
                    header: _('Fecha de Creación'), // Localized header
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Enables text sorting
                    format: dateFormat, // Date format
                },
                {
                    id: 'CurrencyId', // Column ID
                    header: _('Moneda'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                },
                {
                    id: 'Bets', // Column ID
                    header: _('Apuestas'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Thousands separator
                        groupSize: 3, // Group size
                        decimalDelimiter: '.', // Decimal separator
                        decimalSize: 2, // Decimal places
                    }),
                    footer: { content: 'mySummColumn' }, // Footer with custom summary column
                    editor: 'text', // Enables text editing
                },
                {
                    id: 'Winnings', // Column ID
                    header: _('Premios'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Thousands separator
                        groupSize: 3, // Group size
                        decimalDelimiter: '.', // Decimal separator
                        decimalSize: 2, // Decimal places
                    }),
                    footer: { content: 'mySummColumn' }, // Footer with custom summary column
                    editor: 'text', // Enables text editing
                },
                {
                    id: 'Bonus', // Column ID
                    header: _('Bonos'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Thousands separator
                        groupSize: 3, // Group size
                        decimalDelimiter: '.', // Decimal separator
                        decimalSize: 2, // Decimal places
                    }),
                    footer: { content: 'mySummColumn' }, // Footer with custom summary column
                    editor: 'text', // Enables text editing
                },
                {
                    id: 'AmountBase', // Column ID
                    header: _('Valor Base'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Thousands separator
                        groupSize: 3, // Group size
                        decimalDelimiter: '.', // Decimal separator
                        decimalSize: 2, // Decimal places
                    }),
                    footer: { content: 'mySummColumn' }, // Footer with custom summary column
                    editor: 'text', // Enables text editing
                },
                {
                    id: 'Amount', // Column ID
                    header: _('Comision'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Enables integer sorting
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Thousands separator
                        groupSize: 3, // Group size
                        decimalDelimiter: '.', // Decimal separator
                        decimalSize: 2, // Decimal places
                    }),
                    footer: { content: 'mySummColumn' }, // Footer with custom summary column
                    editor: 'text', // Enables text editing
                },
                {
                    id: 'ModifiedLocal', // Column ID
                    header: _('Modificado'), // Localized header
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Enables text sorting
                    format: dateFormat, // Date format
                },
                {
                    id: 'ExternalId', // Column ID
                    header: _('External ID'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Enables integer sorting
                },
            ],
            onClick: {
                /**
                 * Event handler for the "pay" action.
                 * Displays a modal box to select the payment type and processes the payment.
                 * @param {Object} euv - Event object.
                 * @param {string} id - ID of the clicked item.
                 */
                pay: function(euv, id) {
                    var vvthis = this;
                    webix
                        .modalbox({
                            title: _('Pregunta'),
                            buttons: [
                                _('Efectivo'),
                                _('Saldo Recarga'),
                                _('Saldo Juego'),
                                _('Saldo Afiliados'),
                                _('Cancelar'),
                            ],
                            text: _('Seleccione el tipo de saldo '),
                            width: screen.width < 500 ? 300 : 500,
                            height: screen.width < 500 ? 200 : 0,
                        })
                        .then(function(result) {
                            switch (result) {
                                case '0':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsCash',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message('Error! ');
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P';
                                                                webix.message('Comisión Pagada');
                                                                vthis.$$('table').clearAll();
                                                                vthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsRecharge',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message('Error! ');
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P';
                                                                webix.message(_('Comisión Pagada'));
                                                                vthis.$$('table').clearAll();
                                                                vthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsGame',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P';
                                                                webix.message(_('Comisión Pagada'));
                                                                vthis.$$('table').clearAll();
                                                                vthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'),
                                        ok: _('Pagar Nota'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsAffiliates',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                item.State = 'P';
                                                                webix.message(_('Comisión Pagada'));
                                                                vthis.$$('table').clearAll();
                                                                vthis.$$('table').load(url);
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4':
                                    break;
                            }
                        });
                },
                /**
                 * Event handler for the "approve" action.
                 * Displays a confirmation dialog to approve a commission.
                 * @param {Object} euv - Event object.
                 * @param {string} id - ID of the clicked item.
                 */
                approve: function(euv, id) {
                    var vvthis = this;
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'),
                        ok: _('Aprobar Comisión'),
                        cancel: _('Salir'),
                        callback: function(action) {
                            if (action === true) {
                                var item = vvthis.getItem(id);
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission',
                                        '{ "Id":' + item.Id + '}',
                                        {
                                            error: function(text, data, XmlHttpRequest) {
                                                webix.message(_('Error! '));
                                            },
                                            success: function(text, data, XmlHttpRequest) {
                                                item.State = 'P';
                                                webix.message(_('Comisión Aprobado'));
                                                vthis.$$('table').clearAll();
                                                vthis.$$('table').load(url);
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            on: {
                /**
                 * Event triggered before data is loaded into the datatable.
                 * Displays a loading overlay.
                 */
                onBeforeLoad: function() {
                    this.showOverlay(
                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                    );
                },
                /**
                 * Event triggered after data is loaded into the datatable.
                 * Hides the loading overlay.
                 */
                onAfterLoad: function() {
                    this.hideOverlay();
                },
            },
            /**
             * Event triggered when the datatable is ready.
             * Displays a "no data" overlay if the datatable is empty.
             */
            ready: function() {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox);
                    this.showOverlay(
                        '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>',
                    );
                }
            },
            footer: true, // Enables the footer
            math: true, // Enables math operations
            loadahead: 0, // Preloads no additional data
            datafetch: devConfig.getDefaultDataFetch(), // Fetches data based on default configuration
            pager: 'pagerA', // Specifies the pager ID
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Get the localization service from the app
        const _ = this.app.getService('locale')._;
        // Retrieve the current user parameter, ensuring it is required
        const cur_user = this.getParam('user', true);
        // Construct the API URL for fetching commissions
        const url = devConfig.geturlApi() + 'es/Financial/GetComissions?FromId=' + cur_user + '&';
        // Initialize filter variable
        var filter = '';
        // Listen for 'depositReport:filter' event to apply filters
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Process 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Process 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear the grid before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and filters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach event to handle sorting in the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Reload the grid with the sorted data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        // Attach event to handle item clicks in the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            // Get the clicked item details
            var item = this.getItem(id);
            // Trigger an event with the selected item's ID
            this.$scope.app.callEvent('deposit:id', [item.Id]);
        });
        // Listen for 'player:select' event to reload grid data based on selected player
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid with the selected player's data
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
